import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllNotificationRequestedBySme } from "../../slices/socketSlice";
import {
  finalSubmission,
  getUserAllFormsDetails,
  getUserBasicInfo,
  setTabsForPersonalInfo,
} from "../../slices/userSlice";
import GradientButton from "../Button/GradientButton";
import ModalView from "../CustomModal/ModalView";
import GradientText from "../GradientText";
import MyTab from "../Interactions/MyTab";
import NotificationPopover from "../NotificationPopover";
import AcademicAchievements from "./AcademicAchievements";
import AchievementsAndAwards from "./AchievementsAndAwards";
import BasicInformationStep from "./BasicInformationStep";
import EducationalInformationStep from "./EducationalInformationStep";
import InternationalAchievementsTabs from "./InternationalAchievementsTabs";
import NationalAchievementsTabs from "./NationalAchievementsTabs";
import PersonalityAttributes from "./PersonalityAttributes";
import ProfessionalInformationStep from "./ProfessionalInformationStep";
import Publications from "./Publications";
import SignificantAchievements from "./SignificantAchievements";
import { Tooltip } from "antd";
const PersonalInformation = ({ personalInformationTab }) => {
  const [achievement, setAchievement] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const activeTab = useSelector((state) => state.user.activeTabForPersonalInfo);
  let [selectedStepher, setSelectedStepher] = useState();
  const dispatch = useDispatch();
  const userAllFormsDetails = useSelector(
    (state) => state.user.userAllFormsDetails
  );
  const basicInfoData = userAllFormsDetails.find(
    (data) => data.SK === "Profile#BasicInfo"
  );
  const getAllNotificationBySme = useSelector(
    (state) => state.socket.getAllNotification
  );

  console.log(getAllNotificationBySme, "getAllNotificationBySme");

  const finalSubmissionFun = async () => {
    setLoading(true);
    const res = await dispatch(finalSubmission());
    if (res) {
      dispatch(getUserAllFormsDetails());
      dispatch(getUserBasicInfo());
      setLoading(false);
      setModalVisible(false);
    }
  };

  const isTalentApproved = basicInfoData?.AdminApproved === "rejected";
  const alreadyFinalSubmit = basicInfoData?.IsFinalSubmit;
  console.log({ activeTab });
  useEffect(() => {
    // Check if state exists in location object and set selected tab accordingly
    dispatch(getAllNotificationRequestedBySme());
    if (personalInformationTab) {
      dispatch(setTabsForPersonalInfo(personalInformationTab));
    }
  }, [personalInformationTab]);

  //Extract data for notifications

  // const ModifiedData=getAllNotificationBySme?.map( x => {
  //   console.log(x, "xsxsxsxsxsxs")
  // })
  //  console.log({ModifiedData})
//   const transformData = (data) => {
//     if (!data || typeof data !== 'object') {
//         // Return an empty object if data is null, undefined, or not an object
//         return {};
//     }

//     const rawDataKey = Object.keys(data)[0]; // Get the first key dynamically

//     if (!rawDataKey || !Array.isArray(data[rawDataKey])) {
//         // Return an empty object if the key is not found or the value is not an array
//         return {};
//     }

//     const rawData = data[rawDataKey];

//     const result = rawData.reduce((acc, item) => {
//         if (item && Array.isArray(item.Section)) {
//             item.Section.forEach(sectionKey => {
//                 if (!acc[sectionKey]) {
//                     acc[sectionKey] = [];
//                 }
//                 acc[sectionKey].push({
//                     CreatedAt: item.CreatedAt || '',
//                     Description: item.Description || '',
//                     PK: item.PK || '',
//                     SK: item.SK || '',
//                     SmeId: item.SmeId || ''
//                 });
//             });
//         }
//         return acc;
//     }, {});

//     return result;
// };

// Helper function to merge multiple arrays with different keys into a unified format
const transformData = (data) => {
  if (!data || typeof data !== "object") return {};

  const result = Object.values(data).reduce((acc, rawDataArray) => {
    rawDataArray.forEach((item) => {
      if (Array.isArray(item.Section)) {
        item.Section.forEach((sectionKey) => {
          if (!acc[sectionKey]) {
            acc[sectionKey] = [];
          }
          acc[sectionKey].push({
            CreatedAt: item.CreatedAt || "",
            Description: item.Description || "",
            PK: item.PK || "",
            SK: item.SK || "",
            SmeId: item.SmeId || "",
          });
        });
      }
    });
    return acc;
  }, {});
  return result;
};

  const transformedData = transformData(getAllNotificationBySme);
  console.log({ transformedData });

  const basicInfo = transformedData && transformedData["Profile#BasicInfo"];
  const EducationalInfo =
    transformedData && transformedData["Profile#EducationalInfo"];
  const personalInfo =
    transformedData && transformedData["Profile#ProfessionalInfo"];
  const publication =
    transformedData && transformedData["Profile#PublicationInfo"];
  const SoftSkillsNotification =
    transformedData && transformedData["Skills#Soft"];
  const SpecialTalentNotification =
    transformedData && transformedData["SpecialTalent#"];
  const PsychologicalChallengeNotification =
    transformedData && transformedData["Talent#Challenges#Psychological"];
  const SocialChallengesNotification =
    transformedData && transformedData["Talent#Challenges#Social"];
  const ActivityDataNotification =
    transformedData && transformedData["Activity#ExtraCurricular"];
  const LanguageDataNotification =
    transformedData && transformedData["Add#Languages"];
  const WebsiteDataNotification =
    transformedData && transformedData["Add#Website"];
  const NationalAchievementsNotification =
    transformedData && transformedData["Achievements#National"];
  const InternaltionalAchievementsNotification =
    transformedData && transformedData["Achievements#International"];

  console.log(personalInfo, "basincInfoooooooooooo");
  const items = [
    {
      key: "1",
      label: (
        <div className="flex justify-between">
          <div className="flex flex-col">
            <h1 className="mr-4">General</h1>
            <p className="text-[10px] !text-MeduimGrey">
              View and edit general personal information
            </p>
          </div>
          <NotificationPopover notifications={basicInfo} />
        </div>
      ),

      children: <BasicInformationStep />,
    },
    {
      key: "2",
      label: (
        <div className="flex justify-between">
          <div className="flex flex-col">
            <h1>Educational</h1>
            <p className="text-[10px] !text-MeduimGrey">
              View and edit educational qualifications
            </p>
          </div>
          <NotificationPopover notifications={EducationalInfo} />
        </div>
      ),

      children: <EducationalInformationStep />,
    },
    {
      key: "3",
      label: (
        <div className="flex justify-between">
          <div className="flex flex-col">
            <h1 className="mr-7">Professional</h1>
            <p className="text-[10px] !text-MeduimGrey">
              View and edit professional experience
            </p>
          </div>
          <NotificationPopover notifications={personalInfo} />
        </div>
      ),

      children: <ProfessionalInformationStep />,
    },
    {
      key: "10",

      label: (
        <div className="flex justify-between">
          <div className="flex flex-col">
            <h1>Awards & Recognitions</h1>
            <p className="text-[10px] !text-MeduimGrey">
              View, add, update achievements accomplished
            </p>
          </div>
          <NotificationPopover
            notifications={
              InternaltionalAchievementsNotification ||
              NationalAchievementsNotification
            }
          />
        </div>
      ),

      children: (
        <AchievementsAndAwards
          InternaltionalAchievementsNotification={
            InternaltionalAchievementsNotification
          }
          NationalAchievementsNotification={NationalAchievementsNotification}
        />
      ),
    },
    {
      key: "12",
      label: (
        <div className="flex justify-between">
          <div className="flex flex-col">
            <h1>Publications</h1>
            <p className="text-[10px] !text-MeduimGrey">
              View, add, update Publications
            </p>
          </div>
          <NotificationPopover notifications={publication} />
        </div>
      ),
      children: <Publications />,
    },
    {
      key: "11",
      label: (
        <div className="flex justify-between">
          <div className="flex flex-col">
            <h1>Personality Attributes</h1>
            <p className="text-[10px] !text-MeduimGrey">
              View, add, update soft skills, special talent, extra curriculars
              and challenges faces
            </p>
          </div>
          <NotificationPopover
            notifications={
              SoftSkillsNotification ||
              SpecialTalentNotification ||
              PsychologicalChallengeNotification ||
              SocialChallengesNotification ||
              ActivityDataNotification ||
              LanguageDataNotification ||
              WebsiteDataNotification
            }
          />
        </div>
      ),
      children: (
        <PersonalityAttributes
          notifications={{
            SoftSkillsNotification,
            SpecialTalentNotification,
            PsychologicalChallengeNotification,
            SocialChallengesNotification,
            ActivityDataNotification,
            LanguageDataNotification,
            WebsiteDataNotification,
          }}
        />
      ),
    },
  ];
  return (
    <div className={`w-[${isTalentApproved ? "845px" : "100%"}]`}>
      {achievement === "International Achievement" ? (
        <InternationalAchievementsTabs
          setAchievement={setAchievement}
          setSelectedStepher={setSelectedStepher}
        />
      ) : achievement === "National Achievement" ? (
        <NationalAchievementsTabs
          setAchievement={setAchievement}
          setSelectedStepher={setSelectedStepher}
        />
      ) : achievement === "Academic Achievement" ? (
        <AcademicAchievements
          setAchievement={setAchievement}
          setSelectedStepher={setSelectedStepher}
        />
      ) : achievement === "Significant Achievement" ? (
        <SignificantAchievements
          setAchievement={setAchievement}
          setSelectedStepher={setSelectedStepher}
        />
      ) : (
        <div className="bg-pureWhite px-4 py-6 rounded-xl">
          <div className="flex items-center">
            {alreadyFinalSubmit && (
              <p className="text-green-500 font-semibold gap-y-5">
                Thank you for submitting the form for final submission
              </p>
            )}
            <Tooltip
              title={
                alreadyFinalSubmit
                  ? "You already submit the form for final submission"
                  : ""
              }
            >
              <GradientButton
                onClick={() => setModalVisible(true)}
                className="ml-auto"
                disabled={alreadyFinalSubmit}
              >
                Final Submission
              </GradientButton>
            </Tooltip>
          </div>
          <MyTab
            value={selectedStepher}
            // setSelectedStepher={setSelectedStepher}
            // setAchievement={setAchievement}
            items={items}
            activeTab={activeTab}
          />
          {/* {currentDisplayJsx} */}
        </div>
      )}
      <ModalView
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        footer={false}
      >
        <div className="flex justify-center flex-col items-center gap-5 p-5">
          <GradientText className={"font-semibold text-lg"}>
            Warning
          </GradientText>
          <p className="text-base">
            Are you sure you want to submit for final submission? You won&apos;t
            be able to make any changes after that.
          </p>
          <GradientButton loading={loading} onClick={finalSubmissionFun}>
            Submit
          </GradientButton>
        </div>
      </ModalView>
    </div>
  );
};
export default PersonalInformation;
